export const MOCK_OFFICE_CODE_OPTIONS = [
  { id: 1, code: 'L', label: 'London' },
  { id: 2, code: 'B', label: 'Bangalore' },
  { id: 3, code: 'N', label: 'New York' },
  { id: 4, code: 'S', label: 'Singapore' },
  { id: 5, code: 'T', label: 'Toronto' },
  { id: 6, code: 'Y', label: 'Sydney' },
  { id: 7, code: 'J', label: 'Tokyo' },
  { id: 8, code: 'M', label: 'Mumbai' }
];

export const MOCK_OPPORTUNITY_OWNER_OPTIONS = [
  { name: 'John Doe', email: 'john.doe@example.com' },
  { name: 'Jane Smith', email: 'jane.smith@example.com' },
  { name: 'Mike Johnson', email: 'mike.johnson@example.com' },
  { name: 'Sarah Wilson', email: 'sarah.wilson@example.com' },
  { name: 'David Brown', email: 'david.brown@example.com' }
];

export const MOCK_RESEARCH_USER_OPTIONS = [
  { id: 'u1', name: 'Alice', email: 'alice@example.com' },
  { id: 'u2', name: 'Bob', email: 'bob@example.com' },
  { id: 'u3', name: 'Charlie', email: 'charlie@example.com' },
  { id: 'u4', name: 'Diana', email: 'diana@example.com' },
  { id: 'u5', name: 'Edward', email: 'edward@example.com' }
];

export const MOCK_CLAIM_WORDING_OPTIONS = [
  {
    id: 'cw1',
    text: 'Market leader in consumer goods with 40% market share',
    category: 'Market Leadership'
  },
  {
    id: 'cw2', 
    text: 'Fastest growing brand in the premium segment',
    category: 'Growth'
  },
  {
    id: 'cw3',
    text: 'Most innovative product launch of 2024',
    category: 'Innovation'
  },
  {
    id: 'cw4',
    text: 'Leading distribution network across Europe',
    category: 'Distribution'
  },
  {
    id: 'cw5',
    text: 'Top-rated customer satisfaction in the industry',
    category: 'Customer Satisfaction'
  },
  {
    id: 'cw6',
    text: 'Pioneer in sustainable packaging solutions',
    category: 'Sustainability'
  },
  {
    id: 'cw7',
    text: 'Dominant position in digital commerce platforms',
    category: 'Digital Leadership'
  },
  {
    id: 'cw8',
    text: 'Exclusive partnership with major retail chains',
    category: 'Partnerships'
  },
  {
    id: 'cw9',
    text: 'Superior product quality and performance',
    category: 'Quality'
  },
  {
    id: 'cw10',
    text: 'First to market with breakthrough technology',
    category: 'Innovation'
  }
];